import React from 'react';
import styled, { css } from 'styled-components';

import type { ITimelineHour } from '@/types/calendar';

import { HOUR_IN_PX } from '@/config/variables';
import { colors, otherColors } from '@/styles/colors';

interface IProps {
  hour: ITimelineHour;
}

const TimelineHour = ({ hour }: IProps): React.ReactElement => {
  return (
    <Container isTzChange={Boolean(hour.tz)}>
      <HourLabel>{hour.hour}</HourLabel>
      <AmPmSignLabel>
        {hour.note} {hour.tz && `(${hour.tz})`}
      </AmPmSignLabel>
    </Container>
  );
};

export { TimelineHour };

const Container = styled.div<{ isTzChange: boolean }>`
  height: ${HOUR_IN_PX}px;
  line-height: 1;
  color: ${otherColors.calendar.text};
  padding-right: 4px;

  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  flex-direction: column;

  ${({ isTzChange }) =>
    isTzChange &&
    css`
      color: ${otherColors.punch_red};
      background-color: ${colors.red.c100};
    `}
`;

const HourLabel = styled.div`
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;

  position: relative;
  top: -7px;
`;

const AmPmSignLabel = styled.div`
  font-size: 10px;
  font-weight: 400;

  position: relative;
  top: -7px;
`;
